import { render } from "./reset_pass.vue?vue&type=template&id=39722f46&scoped=true"
import script from "./reset_pass.vue?vue&type=script&lang=js"
export * from "./reset_pass.vue?vue&type=script&lang=js"

import "./reset_pass.vue?vue&type=style&index=0&id=39722f46&scoped=true&lang=scss"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39722f46"]])

export default __exports__